"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var AuthLayout = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement(antd_1.Layout, null,
        react_1.default.createElement(antd_1.Layout.Content, null,
            react_1.default.createElement("div", null, children))));
};
exports.default = AuthLayout;
//# sourceMappingURL=index.js.map